import styled from 'styled-components';
import userCustomContent from 'styles/userCustomContent';
import { ReactSVG } from 'react-svg';
import { mediaBreakpointDown } from '../../../styles/grid';
import crossIconSVG from '../../../icons/cross.svg';

const modalMobileBreakpoint = mediaBreakpointDown.sm;

export const CloseButtonContainer = styled.button<{ closable: boolean }>`
  border: none;
  padding: 0;
  appearance: none;

  position: absolute;
  right: 15px;
  transform: translateY(-50%);
  top: 50%;
  width: 35px;
  height: 35px;
  opacity: 0.8;
  background-color: ${({ theme }) => theme.configs.secondaryBox.bgColor};
  border-radius: 30px;
  cursor: pointer;
  display: ${({ closable }) => (closable ? 'flex' : 'none')};
  justify-content: center;
  align-items: center;

  &:focus-visible {
    border-radius: 50%;
  }

  ${modalMobileBreakpoint} {
    right: 8px;
  }
`;

export const CrossIcon = styled(ReactSVG).attrs((props) => ({
  src: crossIconSVG,
  ...props,
}))`
  svg {
    width: 24px;
    height: 24px;
    color: ${({ theme }) => theme.configs.secondaryBox.fontColor};
  }
`;

export const HeaderContainer = styled.div`
  font-size: 18px;
  line-height: 16px;
  font-weight: 700;
  padding: 22px 55px;
  text-align: center;
  position: relative;
  background-color: ${({ theme }) => theme.configs.mainBox.bgColor};
  color: ${({ theme }) => theme.configs.mainBox.fontColor};
  ${userCustomContent}
`;
